import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  search: '',
};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    clearSearch: (state) => {
      state.search = '';
    },
  },
});

export const { setSearch, clearSearch } = filterSlice.actions;
export default filterSlice.reducer; 